export default class ResponseParser {

    getFilenameFromHeaders(headers) {
        let headerLine = headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('"') + 1;
        let endFileNameIndex = headerLine.lastIndexOf('"');
        return headerLine.substring(startFileNameIndex, endFileNameIndex);
    }
}
